import { Box, Card, Grid, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { apiList, config, InvokeApi } from '../../../services/ApiServices';
import Contact from './Contact';

const BlogDetail = () => {
    const { ogUrl } = useParams();
    const [blogData, setBlogData] = useState(null);
    const [error, setError] = useState(null);
    const isMobile = useMediaQuery("(max-width: 768px)");
    const theme_color = '#0169b0';

    useEffect(() => {
        const loadData = async () => {
            try {
                setError(null);

                const response = await InvokeApi(
                    config.podarJuniors + apiList.getArticleByOgUrl,
                    { ogUrl: ogUrl }
                );

                if (response?.status === 200) {
                    setBlogData(response.data.article[0]);
                } else {
                    setBlogData(null);
                }
            } catch (err) {
                console.log('Error loading data:', err);
                setError('Failed to load article. Please try again.');
                setBlogData(null);
            }
        };

        loadData();
    }, [ogUrl]);

    return (
        <Grid>
            {error && <Typography color="error">{error}</Typography>}

            {blogData && (
                <Grid
                    container
                    spacing={6}
                    sx={{
                        backgroundColor: theme_color,
                        p: isMobile ? 2 : 5,
                    }}
                    alignItems="center"
                >
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        {blogData?.blogTitle &&
                            <Typography
                                variant={isMobile ? 'h4' : 'h3'}
                                sx={{ color: 'white', fontWeight: 'bold', mb: 2 }}
                            >
                                {blogData?.blogTitle}
                            </Typography>}

                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <Typography sx={{ color: 'white', fontWeight: 600, fontSize: 16 }}>
                                Updated On:
                            </Typography>
                            <Typography sx={{ color: 'white', ml: 1, fontSize: 14 }}>
                                {blogData.date}
                            </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <Typography sx={{ color: 'white', fontWeight: 600, fontSize: 16 }}>
                                Author:
                            </Typography>
                            <Typography sx={{ color: 'white', ml: 1, fontSize: 14 }}>
                                {blogData.author}
                            </Typography>
                        </Box>

                        {/* <Typography sx={{ color: 'white', fontWeight: 600, fontSize: 16 }}>
                            {blogData.readTime} mins read · {blogData.views} Views
                        </Typography> */}
                    </Grid>

                    <Grid
                        item xs={12} sm={12} md={6} lg={6}
                        sx={{
                            display: 'flex',
                            justifyContent: 'center'
                        }}
                    >
                        <Box
                            component="img"
                            src={blogData.featuredUrl}
                            alt={blogData.blogTitle}
                            sx={{
                                width: '100%',
                                maxWidth: 600,
                                height: 'auto',
                                borderRadius: 2,
                                objectFit: 'cover'
                            }}
                        />
                    </Grid>
                </Grid>
            )}
            <Grid container spacing={6} sx={{ p: isMobile ? 1 : 4 }}>
                <Grid item xs={12} sm={12} md={8} lg={8}>
                    <Card sx={{ borderRadius: 2, p: isMobile ? 1 : 5, boxShadow: 5, border: `1px solid ${theme_color}` }}>
                        {blogData?.blogTitle &&
                            <Typography
                                variant={isMobile ? 'h5' : 'h5'}
                                sx={{ color: theme_color, fontWeight: 'bold', mb: 2 }}
                            >
                                {blogData?.blogTitle}
                            </Typography>}

                        {blogData?.tableOfContent && (
                            <Typography
                                component="div"
                                sx={{ mt: 2 }}
                                dangerouslySetInnerHTML={{
                                    __html: blogData.tableOfContent
                                }}
                            />)}
                        {blogData?.blogContent && (
                            <Typography
                                component="div"
                                sx={{ mt: 2 }}
                                dangerouslySetInnerHTML={{
                                    __html: blogData.blogContent
                                }}
                            />)}
                    </Card>
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Box
                        sx={{
                            position: 'sticky',
                            top: 100,
                            maxHeight: 'calc(100vh - 120px)',
                            overflowY: 'auto', 
                        }}
                    >
                        <Contact pages={'sidebar'} />
                    </Box>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default BlogDetail;
